import { useTranslation } from 'react-i18next';
import Flex from './Flex';
import Text from './Text';

const NoResultsFound = () => {
    const { t } = useTranslation();
    return (
        <Flex align="center" justify="center">
            <Text>{t('noResultsFound', 'No results found')}</Text>
        </Flex>
    );
};

export default NoResultsFound;
